<template>
  <section>
    <div class="swiper-container animated fadeIn">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(slide, index) in swiperSlides" :key="index">
          <a class="boxa" @click="See(slide.detailUrl)">
            <div class="bg" v-show="slide.imageName == '' ? false : true">
              <span
                :class="[slide.positionSx, slide.positionZy]" 
                :style="{
                  top:(slide.positionSx == 'top' ? slide.positionWy1 + 'px' : 'auto'),
                  bottom:(slide.positionSx == 'top' ? 'auto' : slide.positionWy1 + 'px'),
                  left:(slide.positionZy == 'left' ? slide.positionWy2 + 'px' : 'auto'),
                  right:(slide.positionZy == 'left' ?'auto' : slide.positionWy2 + 'px' ),
                  }">{{slide.imageName}}
              </span>
            </div>
            <img :ref="'urlimg' + index" :src="urlBanner + slide.imageUrl" :title="slide.imageName"/>
          </a>
        </div>
  　　</div>
    </div>
  　<div class="swiper-pagination swiprRem" slot="pagination"></div>
    <!-- <swiper :options="swiperOption"  ref="mySwiper">
      <swiper-slide :style="{height: modeHeight}" v-for="(slide, index) in swiperSlides" :key="index">
        <a class="boxa" :href="slide.url">
          <div class="bg" v-show="slide.imageName == '' ? false : true">
            <span
              :class="[slide.positionSx, slide.positionZy]" 
              :style="{
                top:(slide.positionSx == 'top' ? slide.positionWy1 + 'px' : 'auto'),
                bottom:(slide.positionSx == 'top' ? 'auto' : slide.positionWy1 + 'px'),
                left:(slide.positionZy == 'left' ? slide.positionWy2 + 'px' : 'auto'),
                right:(slide.positionZy == 'left' ?'auto' : slide.positionWy2 + 'px' ),
                }">{{slide.imageName}}
            </span>
          </div>
          <img :ref="'urlimg' + index" :src="urlBanner + slide.imageUrl" :title="slide.imageName"/>
        </a>
      </swiper-slide>
    </swiper> -->
    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
  </section>
</template>

<script>

// import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Swiper from 'swiper'
// import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../../../node_modules/swiper/dist/css/swiper.min.css'
import { reqBanners } from '../../untils/api.js'

export default {
  name: 'Swiper',
  data () {
    return {
      // modeHeight: 'auto',
      urlBanner: this.$store.state.baseURL + '/iveco/navigat/getNavigateImge?fileName=',
      swiperSlides: [
        // {title: '全新登場 - NEW DAILY 縱橫天下  賺錢達利​', url: 'javascript:;', img: 'http://www.dg-hyundai.com/kamlung/image/iveco/web-banner1-1440x400.jpg'},
      ],
      currentPage: 1,
      pageSize: 10
    }
  }, 
  created() {
  },
  mounted() {
    // setTimeout(() => {
    //   let mySwiper = new Swiper('.swiper-container', { 
    //     effect: 'fade',
    //     spaceBetween: 30,
    //     autoHeight: true,
    //     // loop: true,
    //     pagination: {
    //       el: '.swiper-pagination',
    //       clickable: true
    //     },
    //     autoplay:{
    //       delay: 5000,  // 设置轮播的时间
    //       disableOnInteraction: false,  // 这一行是为了避免手动滑动轮播图后，自动轮播失效，默认为true
    //     },
    //     // direction:"horizontal", /*横向滑动*/ 
    //     // loop:true, //形成环路（即：可以从最后一张图跳转到第一张图 
    //     // pagination:".swiper-pagination", /*分页器*/ 
    //     // autoplay:3000 /*每隔3秒自动播放*/ 
    //   })
    // }, 1000)
    

    let data = {
      currentPage: this.currentPage,
      pageSize: this.pageSize
    }
    this.bannerList(data)
  },
  
  methods: {
    See (e) {
      if (e == '' || e == null) {
        return false
      } else {
        window.open(e, '_blank')
      }
      // window.location.href = e
    },
    initSwiper() {
      setTimeout(() => {
        let mySwiper = new Swiper('.swiper-container', { 
          effect: 'fade',
          spaceBetween: 30,
          // autoHeight: true,
          observer: true, 
          observeParents: true, 
          // loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: 5000,
          autoplay: {
            delay: 5000,  // 设置轮播的时间
            disableOnInteraction: false,  // 这一行是为了避免手动滑动轮播图后，自动轮播失效，默认为true
          },
          // direction:"horizontal", /*横向滑动*/ 
          // loop:true, //形成环路（即：可以从最后一张图跳转到第一张图 
          // pagination:".swiper-pagination", /*分页器*/ 
          // autoplay:3000 /*每隔3秒自动播放*/ 
        })
      }, 500)
    },
    bannerList(data) {
      reqBanners(data).then(res => {
        if(res.code == 200){
          let data = res.data.data
          if ( data.total > 10) {
            let dataMax = {
              currentPage: this.currentPage,
              pageSize: data.total
            }
            reqBanners(dataMax).then(resMax => {
              if(resMax.code == 200){
                let dataMax = resMax.data.data
                this.swiperSlides = dataMax.list
                setTimeout(() => {
                  this.initSwiper()
                }, 0)
                // console.log('resMax', resMax)
                
                // setTimeout(() => {
                //   if (this.$refs.urlimg1[0].offsetHeight !== this.$refs.urlimg0[0].offsetHeight) {
                //     this.modeHeight = 'auto'
                //     console.log('this.$refs.urlimg1', this.$refs.urlimg1)
                //     console.log('this.$refs.urlimg1', this.$refs.urlimg0)
                //   }
                // },300)
              }
              // console.log('sssssssssssssssssssssss', this.swiperSlides)
            })
          } else {
            this.swiperSlides = data.list
            setTimeout(() => {
              this.initSwiper()
            }, 0)
          }
        }
      })
    }
  }, 
  // watch: {
  //   swiperSlides() {    
  //     let data = {
  //       currentPage: this.currentPage,
  //       pageSize: this.pageSize
  //     }
  //     this.$nextTick(() => {
  //       this.bannerList(data)
  //     })
  //   }
  // }
}
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>

  section {
    background: #fff;
    margin-bottom: 45px;
    margin-top: 50px;
    position: relative;
    .boxa {
      width: 100%;
      height: 100%;
      display: inline-block;
      .bg {
        span {
          font-family: "GillSansBold", "Microsoft YaHei", Arial, sans-serif;
          font-size: 19px;
          background: rgba(0,0,0,0.7);
          color : #fff;
          padding: 8px 10px;
          width: 100%;
          display: inline-block;
        }
      }
      img {
        margin: 0 auto;
      }
    }
    .swiper-slide {
      background: #fff;
    }
    .swiper-container {
      margin-bottom: 40px;
      // overflow: initial;
      .swiper-wrapper {
        // height: auto;
        cursor: pointer;
      }
    }
    .swiper-pagination {
      width: 100%;
      bottom: -32px;
      // padding: 5px 0;
    }
  }

  
  @media (min-width: 768px) {
    .top {
      top: 20px;
    }
    .bottom {
      bottom: 20px;
    }
    .left {
      left: 20px;
    }
    .right {
      right: 20px;
    }

    section {
      .boxa {
        position: relative;
        .bg {
          height: 100%;
          position: absolute;
          left: 50%;
          span {
            font-size: 22px;
            width: auto;
            white-space: pre-line;
            position: absolute;
            z-index: 20;
          }
        }
        img {
          position: relative;
          z-index: 10
        }
      }
    }
  }
  @media (min-width: 992px) {
    section {
      margin-top: 0;
      .boxa {
        .bg {
          span {
            font-size: 28px;
          }
        }
      }
    }
  }

  //窗口响应式
  // @media (min-width: 992px) and (min-width: 768px) {
  @media (min-width: 768px) {
    section {
      .boxa {
        .bg {
          width: 740px;
          margin-left: -370px;
          display: initial;
        }
      }
    }
  }
  @media (min-width: 992px) {
    section {
      .boxa {
        .bg {
          width: 960px;
          margin-left: -480px;
        }
      }
    }
  }
  @media (min-width: 1200px) {
    section {
      .boxa {
        .bg {
          width: 990px;
          margin-left: -495px;
        }
      }
    }
  }


</style>

<style>
  .swiper-pagination .swiper-pagination-bullet {
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;
    margin: 0 6px;
    padding: 0;
    opacity: 0.25;
    background: black;
    cursor: pointer;
  }
  .swiper-pagination .swiper-pagination-bullet:hover {
    opacity: 0.75;
  }
  .swiper-pagination .swiper-pagination-bullet-active {
    opacity: 0.75;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Swiper.vue